import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import CountUp from 'react-countup';
import 'leaflet/dist/leaflet.css';
import projectsData from './projects.json';
import { useInView } from 'react-intersection-observer';

const categoryColors = {
    epurare: '#52c41a',     // Verde
    canalizare: '#1890ff',   // Albastru
    apeduct: '#722ed1'       // Violet
  };
  
  const categoryLabels = {
    epurare: 'Epurare',
    canalizare: 'Canalizare',
    apeduct: 'Apeduct'
  };
  
  const statusLabels = {
    finalizat: 'Finalizat',
    in_constructie: 'În construcție'
  };
  
  // Icon marker custom
  const createCustomIcon = (color) => {
    const iconSvg = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="${color}" stroke="white" stroke-width="2"/>
        <circle cx="12" cy="12" r="5" fill="white"/>
      </svg>
    `;
    return L.divIcon({
      html: iconSvg,
      className: '',
      iconSize: [24, 24],
      iconAnchor: [12, 12],
      popupAnchor: [0, -12]
    });
  };
  
  function MapController({ center, zoom }) {
    const map = useMap();
    useEffect(() => {
      if (center && zoom) {
        map.setView(center, zoom);
      }
    }, [map, center, zoom]);
    return null;
  }

  


function AboutThree() {
    
    const { ref, inView } = useInView({
        triggerOnce: true, // Trigger the animation only once when in view
        threshold: 0.5, // 50% of the element needs to be visible for it to trigger
    });


    const [mapCenter] = useState([47.0105, 28.8637]);
    const [mapZoom] = useState(7);
    const [filteredProjects] = useState(projectsData);


    return (
        <div>
            {/* start about area two */}
            <div className="rts-about-area-two rts-section-gap about-two-bg">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-5">
                        <div className="col-lg-7 pl--50 pl_md--15 pl_sm--15">
                            <div className="about-right-three">
                                <div className="title-area-about-three">
                                    <span className="sub">Construim Moldova </span>
                                    <h2 className="title">
                                    <h2 className="title counter animate__animated animate__fadeInDownBig">
                                    <div className="counter-details" ref={ref}>
                                        {inView && ( // Only render CountUp when the element is in view
                                            <h2 className="title counter animate__animated animate__fadeInDownBig">
                                                <CountUp start={0} end={200} delay={0} duration={1} />
                                                <span className='text-2xl font-bold' >+</span>
                                            </h2>
                                        )}
                                       
                                    </div>
                                            </h2>
                                        <span className='text-2xl font-bold' >
                                            Proiecte Finalizate
                                        </span>
                                    </h2>
                                </div>
                                <div className="col-lg-10 col-md-6 col-sm-6 col-12 mt-10">
                                            <div className="solution-wrapper">
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Construcții Civile & Industriale</p>
                                                </div>
                                                {/* single business solution */}
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Stații de Epurare Moderne</p>
                                                </div>
                                                {/* single business solution */}
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Sisteme Apă & Canalizare</p>
                                                </div>
                                                {/* single business solution */}
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Casangerii</p>
                                                </div>
                                                {/* single business solution */}
                                            </div>
                                        </div>
                            </div>
                        </div>
                        </div>
                        <div className="col-lg-7 pl--50 pl_md--15 pl_sm--15">
                            <div className="about-right-three">
                            <div className="w-full h-[400px] md:h-[600px] rounded-2xl overflow-hidden shadow-lg bg-white">
                            <MapContainer
                                center={mapCenter}
                                zoom={mapZoom}
                                style={{ width: '100%', height: '100%' }}
                                className="h-full w-full"
                            >
                                <MapController center={mapCenter} zoom={mapZoom} />
                                <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                />
                                {filteredProjects.map((project) => (
                                <Marker
                                    key={project.id}
                                    position={[project.coordonate.lat, project.coordonate.lng]}
                                    icon={createCustomIcon(categoryColors[project.categoria])}
                                >
                                    <Popup>
                                    <div className="font-semibold text-base mb-1">{project.denumire}</div>
                                    <div className="text-xs text-gray-600 mb-1">{categoryLabels[project.categoria]} &middot; {statusLabels[project.statut]}</div>
                                    <div className="text-xs text-gray-700">{project.localitate}</div>
                                    <div className="text-xs text-gray-700">{project.buget}</div>
                                    </Popup>
                                </Marker>
                                ))}
                            </MapContainer>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end about area two */}
        </div>
    )
}

export default AboutThree